import { Component, OnInit } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  form: FormGroup

  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.buildForm()
    this.form.patchValue({
      content: '<h2>Welcome to Ngx Weditor!</h2><p>Replace this content</p>'
    })
  }

  handleSubmit() {
    const { content } = this.form.value
    const { valid } = this.form

    if (valid) {
      console.log('content is ', content)
    } else {
      console.log('invalid form ')
    }
  }

  private buildForm() {
    this.form = this.fb.group({
      content: ['', Validators.required]
    })
  }
}
